import { useMemo } from "react";
const MENUITEMS = [
    { identifier: "account-details", label: "Account Details", icon: "lucide:user", url: "/account-details" },
    { identifier: "my-orders", label: "My Orders", icon: "tabler:receipt", url: "/orders" },
    { identifier: "my-addresses", label: "My Addresses", icon: "lucide:map-pin", url: "/addresses" },
    // { identifier: "my-payments", label: "My Payments", icon: "tabler:credit-card", url: "payment-methods" },
];
export function useAccountMenu() {
    const menuItems = useMemo(() => MENUITEMS, []);
    return useMemo(() => ({
        menuItems,
    }), [menuItems]);
}
